import { aaId } from './aaId';

// We access memberId directly rather than calling getAaId because the
// getAaId function reads the cookie and this can degrade performance.
// eslint-disable-next-line @eslint-react/hooks-extra/no-unnecessary-use-prefix
export const useAaId = (): string | null => {
  return aaId;
};
